import React, { useState, useEffect, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { useParams, useLocation } from 'react-router-dom';
import { getPayment, refundStripePayment } from '../../../api/admin/payments/payments';
import ConfirmationModal from '../../common/ConfirmationModal';
import CentsLoader from '../../common/centsLoader/CentsLoader';
import { PaymentDetails, RefundDetails } from './cards';

const MODAL_TITLE = 'Are you sure you want to refund this payment?';

const Payment = () => {
  const { id } = useParams();
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const paymentOrderId = search.get('orderId');

  const [loading, setLoading] = useState(true);
  const [payment, setPayment] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);

  const fetchPayment = useCallback(async () => {
    try {
      const response = await getPayment(id, paymentOrderId);

      setPayment(response.data.payment);
    } catch (error) {
      console.log(error.response.data.error);
      Sentry.captureException(error);
    }

    setLoading(false);
  }, []);

  useEffect(() => fetchPayment(), [fetchPayment]);

  const handleRefundStripePayment = useCallback(async () => {
    setModalOpen(false);
    setLoading(true);

    try {
      await refundStripePayment(payment.id);
      await fetchPayment();
    } catch (error) {
      setLoading(false);
      console.log(error.response.data.error);
      Sentry.captureException(error);
    }
  }, [fetchPayment, payment]);

  const handleModalToggle = useCallback(() => setModalOpen((isOpen) => !isOpen, []));

  if (loading) return <CentsLoader />;

  return (
    <div className="page-container">
      <div className="payment-page-container">
        <h1 className="payment-header">Payment</h1>
        <div className="payment-content">
          <PaymentDetails data={payment} onHeaderAction={handleModalToggle} />
          <RefundDetails refunds={payment.refunds} />
        </div>
        <ConfirmationModal
          header={MODAL_TITLE}
          onClose={handleModalToggle}
          submitAction={handleRefundStripePayment}
          isOpen={isModalOpen}
        />
      </div>
    </div>
  );
};

export default Payment;
